// import AssessorSummary from '../pages/assessor/details/summary'
import React, { lazy } from 'react'
import { Route, Routes } from 'react-router-dom'

// import TabularLoader from '../components/common/tabularLoader'
import { router_config } from '../configs/route.config'
import ResetPassword from '../pages/userManagement/resetPasswords'
// import ResetPassword from '../pages/userManagement/resetpassword'
import ChildRoute from './components/childRoute'
// import ChildRoute from './components/childRoute'
import GuestRoute from './components/guestRoute'
import UserRoute from './components/userRoute'

const Login = lazy(() => import('../pages/userManagement/login'))
const ForgetPassword = lazy(
  () => import('../pages/userManagement/forgetPassword')
)
const AddressBook = lazy(() => import('../pages/AddressBook'))

const AdminUser = lazy(() => import('../pages/AdminUser'))
const AdminDetails = lazy(() => import('../pages/AdminUser/details'))
// Dashboard

const Dashboard = lazy(() => import('../pages/dashboard/dashboard'))
// staff
// const StaffPage = lazy(() => import('../pages/Staff'))
const StaffList = lazy(() => import('../pages/Staff'))
const routes: any = [
  { slug: 'DASHBOARD', component: <Dashboard /> },
  // {
  //   slug: 'CREATE_STAFF',
  //   component: <StaffPage />,
  // },
  {
    slug: 'STAFF_DIRECTORY',
    component: <StaffList />,
  },
  {
    isAuthRoute: true,
    slug: 'LOGIN',
    component: <Login />,
  },

  {
    isAuthRoute: true,
    slug: 'FORGET_PASSWORD',
    component: <ForgetPassword />,
  },
  {
    isAuthRoute: true,
    slug: 'RESET_PASSWORD',
    component: <ResetPassword />,
  },
  {
    slug: 'ADDRESS_BOOK',
    component: <AddressBook />,
  },

  { slug: 'ADMIN_USER', component: <AdminUser /> },
  { slug: 'ADMIN_USER_DETAILS', component: <AdminDetails /> },
]

export default function MainRoutes() {
  return (
    <Routes>
      {routes.map((route: any) => (
        <React.Fragment key={route.slug}>
          {route.isAuthRoute ? (
            <Route
              element={<GuestRoute>{route.component}</GuestRoute>}
              path={router_config[route.slug]?.path}
              key={router_config[route.slug]?.path}
            />
          ) : (
            <Route
              element={
                <UserRoute slug_key={route.slug}>{route.component}</UserRoute>
              }
              path={router_config[route.slug]?.path}
              key={router_config[route.slug]?.path}
            >
              {route.children?.length && (
                <>
                  {route.children.map((child: any) => (
                    <Route
                      element={
                        <ChildRoute slug_key={child.slug}>
                          {child.component}
                        </ChildRoute>
                      }
                      path={router_config[child.slug]?.path}
                      key={router_config[child.slug]?.path}
                    />
                  ))}
                </>
              )}
            </Route>
          )}
        </React.Fragment>
      ))}

      <Route
        element={
          <UserRoute slug_key="">
            <Dashboard />
          </UserRoute>
        }
        key="*"
        path="*"
      />
    </Routes>
  )
}
